export default __webpack_public_path__ + "static/media/HASSAN_FR_SEQ09.a6d37113.mp3";